import useCountries from "../../../http/public/useCountries";

export default () =>
  useCountries().map((country) =>
    country.name
      .split(" ")
      .map((name) => name.charAt(0) + name.substring(1).toLowerCase())
      .join(" ")
  );
